"use client";
import React, { ReactElement } from "react";
import Image from "next/image";
import styles from "./Header.module.css";
const Logo = "/images/mentorpass-logo-text.png";

interface HeaderProps {
  slug: string;
  show_signup: boolean;
}

const Header = ({ slug, show_signup }: HeaderProps): ReactElement => {
  const goToLogin = () =>
    (window.location.href = `https://app.mentorpass.co/signup?mentor=${slug}`);

  return (
    <div className={styles.container}>
      <div className={styles.logo_container}>
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="16"
          viewBox="0 0 33 16"
          fill="none"
        >
          <path
            d="M26.885 10.1077C26.6478 10.5497 26.1868 10.8254 25.6852 10.8254L20.691 10.8254L26.4998 -2.00272e-05H31.3983C31.8101 -2.00272e-05 32.0729 0.439275 31.8782 0.802082L26.885 10.1077Z"
            fill="#5440F0"
          />
          <path
            d="M15.3862 15.7269H9.57745L17.8826 0.0681028H23.6914L15.3862 15.7269Z"
            fill="#4333C0"
          />
          <path
            d="M6.69484 15.7949H1.79136C1.38077 15.7949 1.11785 15.3579 1.31023 14.9951L8.80745 0.859659C9.04358 0.414457 9.50631 0.136096 10.0103 0.136096H15L6.69484 15.7949Z"
            fill="#2F2486"
          />
        </svg>
        <h1>MENTORPASS</h1> */}
        <img src={Logo} alt="MentorPass" />
      </div>
      {show_signup && (
        <button className={styles.login_btn} onClick={goToLogin}>
          Sign up
        </button>
      )}
    </div>
  );
};

export default Header;
